<template>
    <v-main>
        <v-container :class="$vuetify.breakpoint.xsOnly?'pa-0':''">
            <v-row>
                <v-col cols="12" sm="12" md="6">
                    <v-card>
                        <v-card-title>
                            Send Message
                        </v-card-title>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="auto" justify="space-between" v-for="(u,i) in mediaUrl" :key="u">
                                        <div :style="`width:100px;height:100px;background-image: url(${u});background-position: center;background-size: contain;`">

                                        </div>
                                        <div>
                                            <v-btn icon color="indigo"  @click="mediaUrl.splice(i,1)"  class="ma-0">
                                                <v-icon>{{icons.close}}</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-textarea outlined  rows="5" id="input-107"
                                                    v-model="texttosend"
                                                    @blur="checkDetails($event)">

                                        </v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <span class="font-weight-light title">Will send to the following groups: </span>
                                        <v-chip v-for="(g,i) in $store.state.selectedgroups"
                                                min-width="200"
                                                :key="g.groupkey"
                                                close
                                                :color="$store.state.color1"
                                                text-color="white"
                                                small
                                                @click:close="$store.state.selectedgroups.splice(i,1)">
                                            {{g.name}}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col xs="12" class="py-2 px-5">
                                <span class="font-weight-light title">
                                   Total contacts:
                                </span>
                                        <span class="title">
                                    <v-btn outlined @click="viewContactList()">
                                       {{Object.values($store.state.contactcount).length}}
                                    </v-btn>
                                </span>
                                        <span class="subtitle-1">
                                    {{Object.values(this.$store.state.contactduplicates).length}} duplicate{{Object.values(this.$store.state.contactduplicates).length>1?'s':''}} removed
                                </span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col xs="12">
                                        <v-list flat>
                                            <v-list-item-group>
                                                <v-list-item two-line  @click="insertToken('~[contact-name]~')" >
                                                    <v-list-item-action>
                                                        <v-btn
                                                                :color="insertcontact?$store.state.coloron:'indigo'"
                                                                dark
                                                        >
                                                            <v-icon>{{$store.state.icons.account}}</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Insert Contact
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            inserts a contacts token, will be replaced by receivers full name in the message
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-avatar>

                                                    </v-list-item-avatar>
                                                </v-list-item>
                                                <v-list-item @click="requestyesno = !requestyesno"  >
                                                    <v-list-item-action>
                                                        <v-btn
                                                                :color="requestyesno?$store.state.coloron:'indigo'"
                                                                dark >
                                                            <v-icon>{{icons.exclamation}}</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content >
                                                        <v-list-item-title>
                                                            Request Yes/No
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            Request an answer and tabulate data
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-avatar class="headline">

                                                    </v-list-item-avatar>
                                                </v-list-item>
                                                <v-list-item @click="includeemail = !includeemail"  >
                                                    <v-list-item-action>
                                                        <v-btn
                                                                :color="includeemail?$store.state.coloron:'indigo'"
                                                                dark >
                                                            <v-icon>{{icons.email}}</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content >
                                                        <v-list-item-title>
                                                            Include Email
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            Send a templated copy to contact email?
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-avatar class="headline">

                                                    </v-list-item-avatar>
                                                </v-list-item>
                                                <!--GROUPS NEEDS TO BE 'groups' OR 'archivedgroups'-->
                                                <v-list-item two-line  @click="insertToken('~[nickname]~')" v-if="1===2">
                                                    <v-list-item-action>
                                                        <v-btn
                                                                :color="insertnickname?$store.state.coloron:'indigo'"
                                                                dark >
                                                            <v-icon>{{$store.state.icons.contact}}</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Insert Nickname
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            inserts a nickname token, will be replaced by receivers full name in the message
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-avatar>

                                                    </v-list-item-avatar>
                                                </v-list-item>
                                                <v-list-item @click.native="selectactiveeditdialog=true" >
                                                    <v-list-item-action>
                                                        <v-btn
                                                                :color="$store.state.selectedgroups.length>0?$store.state.coloron:'indigo'"
                                                                dark
                                                        >
                                                            <v-icon>{{$store.state.icons.group}}</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select Group(s)
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            Select groups to send the message to...
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-avatar class="headline white--text" :color="$store.state.coloron" v-if="$store.state.selectedgroups.length>0">
                                                        {{$store.state.selectedgroups.length}}
                                                    </v-list-item-avatar>
                                                </v-list-item>
                                                <!--SELECTED GROUPS ARE SET IN GROUPLIST SUB COMPONENT-->
                                                <v-list-item @click="requestyesno = !requestyesno" v-if="1===2" >
                                                    <v-list-item-action>
                                                        <v-btn
                                                                :color="requestyesno?$store.state.coloron:'indigo'"
                                                                dark >
                                                            <v-icon>fas fa-list</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content >
                                                        <v-list-item-title>
                                                            Request Yes/No
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            Requests a yes/no response from receiver and compiles into report
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-avatar class="headline">

                                                    </v-list-item-avatar>
                                                </v-list-item>
                                            </v-list-item-group>
                                            <GroupsDialog :dialog="selectactiveeditdialog" @close="selectactiveeditdialog=false" :callback="fakecallback" title="Select Groups" :checks="true"   />
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <Uploader :fab="false" />
                            <v-spacer></v-spacer>
                            <FileSelect @selectedfiles="setFiles($event)" />
                            <v-spacer></v-spacer>
                            <BaseBtn  :disabled="!valid" @click="sendtext" :loading="loading">Send <v-icon class="ml-2">{{$store.state.icons.send}}</v-icon></BaseBtn>
                        </v-card-actions>
                        <VDialog v-model="viewcontactsdialog" scrollable>
                            <v-card>
                                <v-card-title>
                                    Selected Contacts
                                </v-card-title>
                                <v-card-text>
                                    <ContactList :contacts="this.$store.state.contactcount" />
                                </v-card-text>
                                <v-card-actions>
                                    <BaseBtn @click="viewcontactsdialog=false">Close</BaseBtn>
                                </v-card-actions>
                            </v-card>
                        </VDialog>
                    </v-card>
                </v-col>
                <v-col cols="6" class="hidden-sm-and-down">
                    <v-card>
                        <v-card-title>Selected Contacts</v-card-title>
                        <v-card-text>
                            <ContactList :contacts="this.$store.state.contactcount" />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import BaseBtn from "@/components/BaseBtn";
  import GroupsDialog from "@/components/groups/GroupsDialog";
  import ContactList from "@/components/contacts/ContactList";
  import Uploader from "../components/uploader/Uploader";
  import FileSelect from "../components/FileSelect";
  export default {
    components: { FileSelect, Uploader, ContactList, GroupsDialog, BaseBtn },
    name: "SendToGroup",
    data () {
      return {
        sendtotext: true,
        viewcontactsdialog:false,
        insertcontact:false,
        insertnickname:false,
        selectgroups:false,
        selectactiveeditdialog:false,
        groupsdialog:false,
        selectedgroups:[],
        includeemail:false,
        requestyesno:false,
        loading:false,
        mediaUrl: []
      }
    },
    computed:{
      ...mapState(['contactduplicates','message','icons']),
      valid(){
        return this.texttosend.length>0
            && this.$store.state.selectedgroups.length>0
            && Object.values(this.$store.state.contactcount).length>0
            && this.$store.state.org.textappy.subAccount
      },
      dupes(){
        return Object.values(this.$store.state.contactduplicates).length
      },
      texttosend:{
        get(){
          return this.message
        },
        set(val){
          this.setMessage(val)
        }
      }
    },
    created () {

    },
    mounted () {

    },
    watch: {

    },
    methods: {
      ...mapActions(['post','setMessage']),
      ...mapMutations(['setMessage']),
      checkDetails(e){
        this.insertcontact = this.texttosend.includes('~[contact]~')
      },
      insertToken(token){ console.log(token)
        if(this.texttosend.includes(token)){
          this.texttosend = this.texttosend.replace(token,'')
          if(token==='~[contact-name]~')this.insertcontact = false
          if(token==='~[nickname]~')this.insertnickname = false
        } else {
          let ctrl = document.getElementById('input-107')
          let s = ctrl.selectionStart;
          let f = this.texttosend;
          this.texttosend = f.slice(0, s) + token + f.slice(s);
          if(token==='~[contact-name]~')this.insertcontact = true
          if(token==='~[nickname]~')this.insertnickname = true
        }
      },
      fakecallback(){return},
      SelectGroups(e){
        this.selectedgroups = e
      },
      sendtext: async function () {
        if (this.$store.state.selectedgroups.length === 0) {
          this.checkboxvalid = false
        }
        this.loading = true;
        if(this.texttosend.length<1){
          return;
        }
        //ONLY SEND AN ARRAY OF GROUP KEYS
        let gps = this.$store.state.selectedgroups.map(m => m.groupkey)
        let body = {
          groups: gps,
          message: this.texttosend,
          loading:false,
          includeemail: this.includeemail,
          mediaUrl: this.mediaUrl,
          issurvey: false,
          question:'',
          answers:this.answers,
          requestyesno: this.requestyesno,
          removeduplicateslist: Object.keys(this.contactduplicates)
        }
        let response = await this.post({path:'api/sendsms/sendtexttogroupv2', body:body})
        this.loading=false;
        if(response.error){
          this.$store.commit('setSnackbar',{
            type: 'warning',
            msg: response.message,
            timeout:6000
          })
          return console.log(response.error)
        }
        this.$store.commit('setSelectedGroups',[])
        this.texttosend=''
        this.insertcontact = false
        this.$store.commit('setSnackbar',{
          type: 'success',
          msg: 'Message sent. Go to the history page to see results',
          timeout:6000
        })
        this.$store.commit('setActiveSentRecord',response.item)
        this.$router.replace('/history')
      },
      async editGroup(g){
        console.log(g)
        let f = await this.$store.dispatch('getGroup',g.sortkey);
        console.log('Group: ', f)
        this.selectedgroup = f.Item;
        this.editgroup=true;
      },
      viewContactList(){
        this.viewcontactsdialog = true;
      },
      setFiles(e){
        console.log(e)
        this.mediaUrl = e
      }
    }
  }
</script>

<style scoped>

</style>